/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_OverlineInputs */

const en_fw_tpl_overline = /** @type {(inputs: Fw_Tpl_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TEMPLATE GALLERY`)
};

const id_fw_tpl_overline = /** @type {(inputs: Fw_Tpl_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GALERI TEMPLATE`)
};

/**
* | output |
* | --- |
* | "TEMPLATE GALLERY" |
*
* @param {Fw_Tpl_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_overline = /** @type {((inputs?: Fw_Tpl_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_overline(inputs)
	return en_fw_tpl_overline(inputs)
});